import { Container, Button } from '@material-ui/core'
import errorIcon from '@/public/images/error-icon.png'
import { useMediaQuery } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import Head from 'next/head'

export const ErrorBoundaryFallback: React.FC<any> = ({
  resetErrorBoundary,
}) => {
  const device = {
    isDesktop: useMediaQuery('(min-width: 960px)'),
    isTablet: useMediaQuery('(max-width: 959px) and (min-width: 710px)'),
    isPhablet: useMediaQuery('(max-width: 709px) and (min-width: 600px)'),
    isMobile: useMediaQuery('(max-width: 709px)'),
  }

  return (
    <>
      <Head>
        <title>Oops, something went wrong</title>
      </Head>
      <Container className="container_contract">
        <div className="container-error center-errors">
          <img id="icon" src={errorIcon.src} className="img-error" />
          <div>
            <h2 id="title">Oops, something went wrong.</h2>
            <p>
              Try reloading the page. If the issue persists, contact our support
              team at{' '}
              <b>
                <a
                  className="support-link"
                  href="mailto:support@hcidoculink.net"
                  target="_blank"
                  rel="noreferrer"
                >
                  support@hcidoculink.net
                </a>
              </b>
            </p>
            <Button
              variant="contained"
              color="primary"
              onClick={resetErrorBoundary}
              startIcon={<ArrowBackIcon />}
            >
              Go back
            </Button>
          </div>
        </div>
      </Container>

      <style jsx>{`
        .container-error {
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          align-content: center;
          justify-content: center;
          align-items: center;
          transform: scale(0.85);
        }
        img.img-error {
          width: ${device.isDesktop || device.isTablet ? '450px' : '225px'};
          height: auto;
        }
        .container-error > div > h2 {
          font-weight: 800;
          font-size: ${device.isDesktop ? '60px' : '30px'};
          line-height: ${device.isDesktop ? '70px' : '35px'};
          color: #0047ba;
          text-align: center;
          margin: 1rem 0;
        }
        .container-error > div > p {
          font-weight: 600;
          font-size: ${device.isDesktop ? '16px' : '14px'};
          line-height: ${device.isDesktop ? '19px' : '10px'};
          color: #9ca3af;
          text-align: center;
          margin: 1rem 0;
        }
        .container-error > div > p > b {
          color: #0047ba;
        }
        :global(.MuiList-root.MuiList-padding) {
          list-style: disc;
        }
        :global(.error-messages p) {
          font-weight: 600;
          font-size: 16px;
          color: #9ca3af;
          line-height: 25px;
          margin: 0.5rem 0;
          text-align: justify;
        }
        :global(.MuiButtonBase-root.MuiButton-root.MuiButton-contained.MuiButton-containedPrimary) {
          color: #fff;
          background-color: #0047ba;
          width: 220px;
          height: ${device.isDesktop || device.isTablet ? '60px' : '45px'};
          display: flex;
          margin: auto;
          flex-direction: row;
          flex-wrap: nowrap;
          align-content: center;
          justify-content: center;
          align-items: center;
          margin-top: 54px;
        }
        a.support-link {
          font-family: 'Inter', 'Be Vietnam', sans-serif;
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 19px;
          text-decoration-line: underline;
          color: #0047ba !important;
        }
      `}</style>
    </>
  )
}

export default ErrorBoundaryFallback
